import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import renderField from '../../Inputs';

const validate = (valueSet) => {
  const values = valueSet;

  const errors = { campaign: {} };
  if (!values.campaign) values.campaign = {};
  if (!values.campaign.gender) errors.campaign.gender = 'Please choose an option';

  return errors;
};

class Gender extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="gender-start compaign-page" ref={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <div className="campaign-bg ie-seperate" style={{ backgroundImage: 'url(/site/images/campaign/lwd-bg-step-1.svg)' }} />
        <Paragraph center>
          <img src="/site/images/campaign/white-logo.svg" alt="" width="134" height="100" />
        </Paragraph>
        <form onSubmit={handleSubmit} className="form-campaign">
          <Heading classes="header-text larger" center>Are You <br />Living Well?</Heading>
          <Paragraph classes="desc-text" center>Please start by telling us your gender.</Paragraph>
          <Field
            name="campaign[gender]"
            type="radiogroup"
            params={{ dataKey: 'gender' }}
            component={renderField}
            centered
          />
          <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
        </form>
        <Paragraph classes="legal-text">The ‘Are you Living Well?’ quiz is a bit of fun! It{"'"}s an indication of how you{"'"}re doing compared to national guidelines. For more guidance on your health please complete register with us after the quiz. The quiz is designed for adults so the results won{"'"}t read correctly for under 18s.</Paragraph>
        <ul className="footer-links">
          <li><a href="/accessibility/">Accessibility</a></li>
          <li><a href="/cookie-policy/">Cookie Policy</a></li>
          <li><a href="/privacy/">Privacy</a></li>
          <li><a href="/terms-and-conditions/">Terms &amp; Conditions</a></li>
          <li><a href="/sitemap/">Sitemap</a></li>
        </ul>
      </div>
    );
  }
}

Gender.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'campaign',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(Gender);



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/Gender.jsx